import React from 'react';
import { motion } from 'framer-motion';
export function ProfitBreakdownSection() {
  const rows = [{
    label: 'Monthly Lease Cost',
    value: '$1,500',
    color: 'text-[#f5f0e8]/80'
  }, {
    label: 'Corporate Rental Income',
    value: '$2,600',
    color: 'text-white font-bold'
  }, {
    label: 'Monthly Net Profit',
    value: '$1,100',
    color: 'text-[#c9a84c] text-xl md:text-2xl font-bold'
  }, {
    label: 'Startup Furniture Cost',
    value: '$3,500 (one-time)',
    color: 'text-[#f5f0e8]/80'
  }, {
    label: 'Payback Period',
    value: '3.2 Months',
    color: 'text-[#c9a84c] font-bold'
  }, {
    label: 'Annualized ROI',
    value: '377%',
    color: 'text-[#c9a84c] text-3xl md:text-4xl font-bold'
  }];
  return <section className="w-full bg-[#111827] py-12 md:py-20 px-4 relative" data-id="element-135">
      {/* Gold Divider */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#c9a84c]" data-id="element-136"></div>

      <div className="max-w-3xl mx-auto" data-id="element-137">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-2xl md:text-4xl text-[#c9a84c] text-center mb-8 md:mb-12" data-id="element-138">
          The Math Behind a Single Shadow Unit
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-[#0f1724] border border-[#c9a84c]/20 rounded-xl overflow-hidden shadow-2xl" data-id="element-139">
          <div className="p-4 md:p-8 space-y-3 md:space-y-6" data-id="element-140">
            {rows.map((row, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`flex justify-between items-center py-3 md:py-4 ${index !== rows.length - 1 ? 'border-b border-[#c9a84c]/10' : ''}`} data-id="element-141">
                <span className="text-[#f5f0e8]/70 text-sm md:text-xl font-medium" data-id="element-142">
                  {row.label}
                </span>
                <span className={`text-right ${row.color}`} data-id="element-143">{row.value}</span>
              </motion.div>)}
          </div>

          <div className="bg-[#c9a84c]/10 p-4 md:p-6 text-center border-t border-[#c9a84c]/20" data-id="element-144">
            <p className="font-serif italic text-[#f5f0e8] text-base md:text-xl" data-id="element-145">
              Now multiply by 3 units. That's{' '}
              <span className="text-[#c9a84c] font-bold" data-id="element-146">$3,300/month</span> —
              from a <span className="line-through text-[#ef4444]/70" data-id="element-147">$47</span>{' '}
              <span className="text-[#c9a84c] font-bold" data-id="element-148">$6.36</span> blueprint.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}